import { NgModule } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import {
  AlertTriangle,
  ArrowLeft,
  Bell,
  BellOff,
  BellRing,
  BarChart3,
  Calendar,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CheckCircle,
  CircleAlert,
  CirclePlus,
  CircleX,
  ClipboardList,
  Clock,
  Coins,
  Copy,
  CreditCard,
  Crown,
  DollarSign,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  Send,
  File,
  FileText,
  Globe,
  Hammer,
  HandCoins,
  Hash,
  HelpCircle,
  Hourglass,
  Image,
  ImagePlus,
  Inbox,
  Info,
  Key,
  AlertCircle,
  Ban,
  FileEdit,
  FileImage,
  Landmark,
  LayoutDashboard,
  Link,
  ListChecks,
  LogOut,
  MapPin,
  Minus,
  Package,
  PackageCheck,
  PackagePlus,
  PackageSearch,
  Paperclip,
  Plus,
  Percent,
  Phone,
  QrCode,
  RefreshCw,
  Ruler,
  Search,
  Settings,
  ShieldCheck,
  ShieldX,
  ShoppingCart,
  Sparkles,
  Store,
  Tag,
  Tags,
  TrendingUp,
  Truck,
  Upload,
  User,
  UserCog,
  UserPlus,
  UserRound,
  Users,
  Wallet,
  X,
  Loader2,
  RotateCcw,
  Layers,
  Wrench,
  MessageSquare,
  Lock,
  Shield,
  List,
  ShoppingBag,
  Zap,
  FileQuestion,
} from 'lucide-angular';

const icons = {
  AlertTriangle,
  ArrowLeft,
  Bell,
  BellOff,
  BellRing,
  BarChart3,
  Calendar,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CheckCircle,
  CircleAlert,
  CirclePlus,
  PlusCircle: CirclePlus,
  CircleX,
  XCircle: CircleX,
  ClipboardList,
  Clock,
  Coins,
  Copy,
  CreditCard,
  Crown,
  DollarSign,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileText,
  Globe,
  Hammer,
  HandCoins,
  Hash,
  HelpCircle,
  Hourglass,
  Image,
  ImagePlus,
  Inbox,
  Info,
  Key,
  AlertCircle,
  Ban,
  FileEdit,
  FileImage,
  Landmark,
  LayoutDashboard,
  Link,
  ListChecks,
  LogOut,
  MapPin,
  Minus,
  Package,
  PackageCheck,
  PackagePlus,
  PackageSearch,
  Paperclip,
  Plus,
  Percent,
  Phone,
  QrCode,
  RefreshCw,
  Ruler,
  Search,
  Send,
  Settings,
  ShieldCheck,
  ShieldX,
  ShoppingCart,
  Sparkles,
  Store,
  Tag,
  Tags,
  TrendingUp,
  Truck,
  Upload,
  User,
  UserCog,
  UserPlus,
  UserRound,
  Users,
  Wallet,
  X,
  Loader2,
  RotateCcw,
  Layers,
  Wrench,
  MessageSquare,
  Lock,
  Shield,
  List,
  ShoppingBag,
  Zap,
  FileQuestion,
};

@NgModule({
  imports: [LucideAngularModule.pick(icons)],
  exports: [LucideAngularModule],
})
export class IconsModule {}
